/**
 * Ad slots configuration for City Browse buckets
 * Defines where promoted events should be placed for each bucket type
 */

// Ad slots configuration for different city browse buckets
// interleaveTwoArrays expects 1-indexed positions
// so [1, 3] would mean 2 ads, 1 in the first position and 1 in the third position
export const CITY_BROWSE_AD_SLOTS_CONFIG = {
    popular_events: [1],
    online_events: [2],
    this_weekend: [2],
    nightlife_events: [2],
};
/**
 * Get ad slots for a specific bucket key
 * @param bucketKey - The bucket key to get ad slots for
 * @returns Array of ad slot positions, empty array if no configuration
 */
export const getCityBrowseAdSlots = (bucketKey: string): number[] => {
    const config =
        CITY_BROWSE_AD_SLOTS_CONFIG[
            bucketKey as keyof typeof CITY_BROWSE_AD_SLOTS_CONFIG
        ];
    return config ? [...config] : [];
};
